// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_3nV6x","title":"_2F6iR","subTitle":"_3t3wm","today":"_24mBa"};